import Constants from "expo-constants";

import {
  ConfigError,
  type PublicConfig,
  validatePublicConfig,
} from "../../config/validate";

export { ConfigError };
export type { AppEnv, PublicConfig } from "../../config/validate";

/**
 * Reads the public config that app.config.ts embedded at build time and validates it again
 * (FR-036, FR-037; research R14). Throws a ConfigError naming the setting; the root layout then
 * renders ConfigErrorScreen instead of running against a wrong default.
 */
export function readPublicConfig(): PublicConfig {
  const extra = Constants.expoConfig?.extra as
    Record<string, unknown> | undefined;
  if (!extra || extra.publicConfig === undefined) {
    throw new ConfigError(
      "publicConfig",
      "publicConfig is missing from the app build (check APP_ENV)",
    );
  }
  return validatePublicConfig(extra.publicConfig);
}
